import { render, staticRenderFns } from "./NoUsageDataTable.vue?vue&type=template&id=3dcd5aff&"
import script from "./NoUsageDataTable.vue?vue&type=script&lang=js&"
export * from "./NoUsageDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports